import React, { useEffect, useState } from 'react'
import TopImage from '../../Assets/images/listing-bnr.webp'
import { ApiConstants } from '../../constants/ApiConstants'
import useMakeRequest from '../../utils/ApiHelper'
import { Link } from 'react-router-dom'
import { PAGINATION } from '../../constants/Constants'
import { encodeID } from '../../utils/Helper'
import { useNavigate } from 'react-router-dom'
import FrontLoader from '../layout/FrontLoader'
import { LanguageConstants } from '../../constants/LanguageConstants'

function Product() {
const [data , setData]=useState([])
const product = useMakeRequest()
const navigate = useNavigate()
const [pagination , setPagination] = useState({page:PAGINATION.PAGE || 0  , pageSize:PAGINATION.PAGESIZE || 10})
  useEffect(()=>{
    const payload ={
    "page":pagination?.page,
    "pageSize":pagination?.pageSize
    }
    product.makeRequest({ payload, url: ApiConstants?.Productlist, toastStatus: false })
  },[pagination])
  useEffect(()=>{
 if(product.status){
  setData(product?.data?.data?.rows)
 }
  },[product?.status])
  useEffect(() => {
    if(product?.data?.data?.count >= 8  && pagination?.pageSize < product?.data?.data?.count){
    const handleScroll = () => {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 100) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          pageSize: prevPagination.pageSize < 20 ? 20 : prevPagination.pageSize, 
        }));
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }
  }, [pagination]);

 const navigatToProductdetailPage =(e:any)=>{
  return navigate(`/productdetail/${encodeID(e?.id)}`)
 } 

  return (
    <>
    {product.loading ? <FrontLoader/> : null}
    <main>

  {/* top banner section start */}
 <section className="main-banner small-banner" style={{ background: `url(${TopImage}) center/cover` }}>
    <div className="container">
       <h1 className="small-banner-heading">{LanguageConstants?.PRODUCTLISTING}</h1>
       <nav className="com-breadcrumb" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/">{LanguageConstants?.HOME}</Link></li>
          <li className="breadcrumb-item active" aria-current="page">{LanguageConstants?.PRODUCTLISTING}</li>
        </ol>
      </nav>
    </div>
 </section>
 {/* top banner section end  */}
    <div className="footer-space">
        <div className="container">
            <div className="row gy-4 gy-md-5">
              {data.length > 0 ? data.map((res:any , i:any)=>(

                <div className="col-6 col-md-3" onClick={()=>navigatToProductdetailPage(res)}  key={i}>
                <div className="pro-sugg-single">
                    <div className="pro-sugg-img">   
                        <img src={res?.product_image_details?.file_path} alt="product" />
                    </div>
                    <div className="pro-sugg-ct">
                        <h3 className="pro-sugg-ttl">{res?.product_details?.name}</h3>
                        <p className="pro-sugg-para">{res?.product_details?.description} <span className="more-view">more...</span></p>
                    </div>
                </div>
                </div>
              )):<p>{LanguageConstants?.DATANOTFOUND}</p>}
              
              </div>
        </div>
    </div>


</main>
</>
  )
}

export default Product